import { render, staticRenderFns } from "./Os.vue?vue&type=template&id=78ef5bf8&"
import script from "./Os.vue?vue&type=script&lang=js&"
export * from "./Os.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports